import { gql } from '@apollo/client';

export const mapByDisEmailQuery = gql`
  mutation mapByDisEmail($disEmail: String!) {
    mapByDisEmail(disEmail: $disEmail)
  }
`;
